import { render, staticRenderFns } from "./ShareManagementHomework.vue?vue&type=template&id=573d6ad4"
import script from "./ShareManagementHomework.vue?vue&type=script&lang=js"
export * from "./ShareManagementHomework.vue?vue&type=script&lang=js"
import style0 from "./ShareManagementHomework.vue?vue&type=style&index=0&id=573d6ad4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports